<script>
	import CustomCheckboxGroup from "src/components/CustomCheckboxGroup/CustomCheckboxGroup.svelte";
	import CustomInput from "src/components/CustomInput/CustomInput.svelte";
	import { Col, Row } from "sveltestrap";

	export let selectedSides;
	export let finalAmount;
	export let remarks;
	export let updateValues;

	let options = [
		{ label: "Front", value: "front" },
		{ label: "Driver Side", value: "driverSide" },
		{ label: "Back", value: "back" },
		{ label: "Passenger Side", value: "passengerSide" },
	];

	function handleCheckboxChange(e) {
		const checkedValues = Array.from(
			document.querySelectorAll(
				"input[type='checkbox'][name='damageSides']:checked"
			)
		).map((checkbox) => checkbox.value);
		updateValues({
			sides: checkedValues,
		});
	}
</script>

<Col xs={6}>
	<Row class="mb-4">
		<Col>
			<Row>
				<Col>
					<label for="email" class="d-block">
						<span>
							Where is the damage?<span class="text-danger"
								>*</span
							>
						</span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col>
					<CustomCheckboxGroup
						{options}
						bind:selected={selectedSides}
						name="damageSides"
						onChange={(e) => {
							handleCheckboxChange(e);
						}}
					/>
				</Col>
			</Row>
		</Col>
	</Row>
	<Row class="mb-4">
		<Col xs={6}>
			<Row>
				<Col>
					<label for="email" class="d-block">
						<span>
							Final Amount<span class="text-danger">*</span>
						</span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col>
					<CustomInput
						type="text"
						placeholder="Enter final amount"
						bind:value={finalAmount}
						onInput={(e) => {
							updateValues({
								amount: e.target.value,
							});
						}}
					/>
				</Col>
			</Row>
		</Col>
	</Row>
	<Row>
		<Col>
			<Row>
				<Col>
					<label for="email" class="d-block">
						<span>
							Remarks<span class="text-danger">*</span>
						</span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col xs={8}>
					<textarea
						type="text"
						bind:value={remarks}
						style="height: 150px;"
						placeholder="Enter remarks"
						class="form-control getgo input"
						on:input={(e) => {
							updateValues({
								remark: e.target.value,
							});
						}}
					/>
				</Col>
			</Row>
		</Col>
	</Row>
</Col>
